// Credits are product units. Payment currencies never change the balance.
export const TRIAL_CREDITS = 1500;
export const CREDIT_SCALE = 10_000_000;
export const LEGACY_CREDITS_PER_EUR = 100;
export type CheckoutCurrency = "local" | "gbp";

// Fixed launch prices: £15 / 1,500 credits. Stripe handles checkout FX;
// payment currency never changes a package's credit quantity.
export const DEFAULT_CREDITS_PER_GBP = 100;
export const CREDIT_PACKAGES = [
  { id: "1500", credits: 1500, amountCents: 1500, currency: "gbp" },
  { id: "3000", credits: 3000, amountCents: 3000, currency: "gbp" },
  { id: "6000", credits: 6000, amountCents: 6000, currency: "gbp" },
  { id: "10000", credits: 10000, amountCents: 10000, currency: "gbp" },
] as const;
export type CreditPackageId = typeof CREDIT_PACKAGES[number]["id"];
export type CreditOffer = {
  id: CreditPackageId;
  credits: number;
  amountCents: number;
  currency: string;
  available: boolean;
};

export type BillingSummary = {
  unlimitedTokens: boolean;
  trialAllowanceCredits: number;
  trialCredits: number;
  availableCredits: number;
  creditMigrationPending: boolean;
  usage: {
    responses: number;
    inputTokens: number;
    outputTokens: number;
    cachedInputTokens: number;
    totalTokens: number;
    purchasedCreditsUsed: number;
    trialCreditsUsed: number;
  };
  purchasedCredits: number;
  canUse: boolean;
  checkoutAvailable: boolean;
  pricingReady: boolean;
  markupPercent: number;
  usdToGbp: number | null;
  creditsPerGbp: number | null;
  textModel: string;
  voiceModel: string;
  rates: { input: number; cached: number; output: number };
  voiceAudioRates: { input: number; cached: number; output: number } | null;
};

export const credits = (value: number) => {
  const format = new Intl.NumberFormat(undefined, { maximumFractionDigits: 2 });
  return value > 0 && value < 0.01 ? `<${format.format(0.01)}` : format.format(value);
};
export const money = (value: number, currency = "GBP") =>
  new Intl.NumberFormat(undefined, { style: "currency", currency }).format(value);
